import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable react/require-default-props */

export default function StyledTextField(_ref) {
  var id = _ref.id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    label = _ref.label,
    name = _ref.name,
    type = _ref.type,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? null : _ref$tabIndex,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? 'off' : _ref$autoComplete,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$helperText = _ref.helperText,
    helperText = _ref$helperText === void 0 ? null : _ref$helperText,
    value = _ref.value,
    _ref$labelAbove = _ref.labelAbove,
    labelAbove = _ref$labelAbove === void 0 ? false : _ref$labelAbove,
    margin = _ref.margin;
  var normalizedValue = value === null ? undefined : value;
  var isControlled = normalizedValue !== undefined;
  var sharedInputProps = {
    id: id,
    className: "form-control".concat(error ? ' is-invalid' : ''),
    name: name,
    type: type,
    onChange: onChange,
    tabIndex: tabIndex,
    autoFocus: autoFocus,
    required: required,
    autoComplete: autoComplete
  };
  if (labelAbove) {
    return /*#__PURE__*/React.createElement("div", {
      className: "mb-3".concat(className ? " ".concat(className) : '')
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: id,
      className: "form-label"
    }, label, required && /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, " *")), isControlled ? /*#__PURE__*/React.createElement("input", _extends({}, sharedInputProps, {
      value: normalizedValue
    })) : /*#__PURE__*/React.createElement("input", _extends({}, sharedInputProps, {
      defaultValue: defaultValue,
      placeholder: label
    })), helperText && /*#__PURE__*/React.createElement("div", {
      className: error ? 'invalid-feedback' : 'form-text'
    }, helperText));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-floating mb-3".concat(className ? " ".concat(className) : '')
  }, isControlled ? /*#__PURE__*/React.createElement("input", _extends({}, sharedInputProps, {
    value: normalizedValue,
    placeholder: label
  })) : /*#__PURE__*/React.createElement("input", _extends({}, sharedInputProps, {
    defaultValue: defaultValue,
    placeholder: label
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id
  }, label, required && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, " *")), helperText && /*#__PURE__*/React.createElement("div", {
    className: error ? 'invalid-feedback' : 'form-text'
  }, helperText));
}
StyledTextField.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  tabIndex: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  margin: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  autoComplete: PropTypes.string,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  labelAbove: PropTypes.bool
};